// extracted by mini-css-extract-plugin
export var label = "_ef-2";
export var slideContainer = "_ef-0";
export var slider = "_ef-1";